import React, { useEffect } from 'react';
import Breadcrumb from '../../components/breadcrumbs';
import SectionTitle from '../../components/dashboard/section-title';
// import CustomerDocuments from '../../components/profile-widgets/customer-documents';
import { Avatar, Table, Skeleton } from 'antd';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getKYCAction } from '../../store/actions/kycActions';
import { BiFile, BiUser } from 'react-icons/bi';
import { dateFormat, utcToLocalDateTime } from '../../utils/dateFormat';
import { replaceUnderscore } from '../../utils/string-helpers';
import { getKycStatus } from '../../utils/get-kyc-status';

function UserKYCDetails() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  let title = t('kyc_details.user_detail_title');
  let breadcrumbsItem = [
    {
      home: true,
      title: 'Customer Panel',
      url: '/',
      last: false,
    },
    {
      home: false,
      title: t('kyc_details.section_title'),
      url: '/customers/kyc',
      last: false,
    },
    { home: false, title: 'User Details', url: '/', last: true },
  ];
  const { currentKyc, currentKycLoading } = useSelector((state) => state.kyc);
  const { customer_id } = useParams();

  useEffect(() => {
    dispatch(getKYCAction(customer_id));
  }, []); // eslint-disable-line

  const columns = [
    {
      title: 'Date',
      dataIndex: 'completed_at',
      render: (text, record) => utcToLocalDateTime(record?.completed_at),
      sorter: (a, b) => a.completed_at?.localeCompare(b.completed_at),
      defaultSortOrder: 'descend',
      width: '15%',
      align: 'left',
    },
    {
      title: 'Document Type',
      dataIndex: 'docType',
      render: (text, record) => replaceUnderscore(record?.document[0]?.type),
      width: '20%',
    },
    {
      title: 'Document Sub Type',
      dataIndex: 'docType',
      render: (text, record) =>
        replaceUnderscore(record?.document[0]?.sub_type),
      width: '20%',
    },
    {
      title: 'KYC Status',
      dataIndex: 'status',
      render: (text, record) => getKycStatus(record?.status),
      width: '20%',
    },
    {
      title: 'Actions',
      dataIndex: 'id',
      sorter: false,
      render: (text, record) => (
        <Link
          to={`/customers/kyc/${customer_id}/document-details/${record.id}`}
        >
          View Details
        </Link>
      ),
      width: '15%',
    },
  ];

  return (
    <>
      <SectionTitle
        title={title}
        right={<Breadcrumb items={breadcrumbsItem} />}
      />
      <div className="flex flex-col sm:flex-row relative bg-white rounded-md shadow-lg border border-grey-200 mb-8">
        <div className="w-2/6 relative py-4 sm:py-8 flex items-center mx-auto">
          <div className="user-cover lg:w-1/2 absolute left-0 top-0 h-full"></div>
          <Avatar
            size={{ xs: 80, sm: 80, md: 80, lg: 80, xl: 160 }}
            style={{
              verticalAlign: 'middle',
            }}
            className="rounded-full flex self-center items-center justify-center mx-auto shadow-xl border-2 border-white w-32 h-32"
            icon={<BiUser />}
          />
        </div>
        <div className="w-4/6 sm:py-8 flex flex-col items-start justify-center">
          <div className="grid grid-cols-1 sm:grid-cols-4 gap-4 w-full p-4">
            <div className="text-sm">
              Legal Name
              <div className="text-base font-bold mt-1">
                {currentKycLoading ? (
                  <Skeleton.Input
                    style={{ width: 120 }}
                    active={currentKycLoading}
                  />
                ) : (
                  currentKyc?.customer?.name
                )}
              </div>
            </div>
            <div className="text-sm">
              Date of Birth
              <div className="text-base font-bold">
                {currentKycLoading ? (
                  <Skeleton.Input
                    style={{ width: 120 }}
                    active={currentKycLoading}
                  />
                ) : (
                  dateFormat(currentKyc?.customer?.dob)
                )}
              </div>
            </div>
            <div className="text-sm">
              Gender
              <div className="text-base font-bold">
                {currentKycLoading ? (
                  <Skeleton.Input
                    style={{ width: 120 }}
                    active={currentKycLoading}
                  />
                ) : (
                  currentKyc?.customer?.gender || '-'
                )}
              </div>
            </div>
            <div className="text-sm">
              Nationality
              <div className="text-base font-bold">
                {currentKycLoading ? (
                  <Skeleton.Input
                    style={{ width: 120 }}
                    active={currentKycLoading}
                  />
                ) : (
                  currentKyc?.customer?.nationality || '-'
                )}
              </div>
            </div>
            <div className="text-sm">
              Mobile Number
              <div className="text-base font-bold">
                {currentKycLoading ? (
                  <Skeleton.Input
                    style={{ width: 120 }}
                    active={currentKycLoading}
                  />
                ) : (
                  `+${currentKyc?.customer.mobile_country} ${currentKyc?.customer?.mobile}`
                )}
              </div>
            </div>
            <div className="text-sm">
              Email
              <div className="text-base font-bold break-words w-100 white-space-normal leading-tight">
                {currentKycLoading ? (
                  <Skeleton.Input
                    style={{ width: 120 }}
                    active={currentKycLoading}
                  />
                ) : (
                  currentKyc?.customer?.email || '-'
                )}
              </div>
            </div>
            <div className="text-sm">
              KYC Reviewed At
              <div className="text-base font-bold">
                {currentKycLoading ? (
                  <Skeleton.Input
                    style={{ width: 120 }}
                    active={currentKycLoading}
                  />
                ) : (
                  utcToLocalDateTime(currentKyc?.customer?.kyc_verified_at) ||
                  '-'
                )}
              </div>
            </div>
            <div className="text-sm">
              KYC Status
              <div className="text-base font-bold">
                {currentKycLoading ? (
                  <Skeleton.Input
                    style={{ width: 120 }}
                    active={currentKycLoading}
                  />
                ) : (
                  getKycStatus(currentKyc?.customer?.kyc_status) || '-'
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="shadow-md bg-white">
        {currentKycLoading ? (
          <Skeleton active paragraph={{ rows: 4 }} />
        ) : currentKyc?.kyc_attempts.length === 0 ? (
          <div className="text-grey-500 mb-6 col-span-4 flex w-full flex-col items-center ant-card-body bg-white shadow rounded py-10">
            <div className="pt-6 pb-4">
              <BiFile className="text-8xl text-gray-100" />
            </div>
            <div className="text-lg font-bold text-blue-anak">
              No KYC Attempts!
            </div>
            <div className="w-full md:w-1/3 text-center py-2 mb-2">
              Sorry! There are no KYC attempt with this user.
            </div>
          </div>
        ) : (
          <Table
            dataSource={currentKyc?.kyc_attempts}
            bordered={true}
            pagination={false}
            columns={columns}
            showSorterTooltip={false}
            rowKey={(record) => record.id}
            scroll={{ x: true }}
          />
        )}
      </div>
    </>
  );
}

export default UserKYCDetails;
